import React, { useState } from 'react';
import { Image, Linking } from "react-native";
import { Checkbox } from '../../Components';
import type { BracketCompetitionProps, CompetitionPlayerBracketProps, MyPlayerProps, PlayerBalanceProps, PlayerBracketProps } from '../../types';
import { BracketComeptitionApi, BracketCompetitionHelpers } from '../api';
import PlayerBalanceCard from './PlayerBalanceCard';
import { Button, Text, View } from '../../Components/Themed';
import { useColors } from '../../constants/useColors';

type JoinCompetitionCardProps = {
    player?:MyPlayerProps,
    loading?:boolean,
    player_bracket?:PlayerBracketProps,
    player_balance?:PlayerBalanceProps,
    bracket_competition:BracketCompetitionProps,
    onRequestAuthenticate:(auth_strategy_id?:string) => void,
    onNotEnoughBalance:(data:{ bracket_competition:BracketCompetitionProps }) => void,
    onEnterCompetition:(cpb:CompetitionPlayerBracketProps, player_bracket?:PlayerBracketProps) => void,
    onClose:() => void
}

const JoinCompetitionCard = ({ player, player_balance, loading, player_bracket, bracket_competition, onRequestAuthenticate, onNotEnoughBalance, onEnterCompetition, onClose }:JoinCompetitionCardProps) => {
    const Colors = useColors();
    const [ disclaimed, setDisclaimed ] = useState(true);
    const [ use_promo_balance, setUsePromoBalance ] = useState(false);

    const buy_in_label = BracketCompetitionHelpers.getBuyInTitle(bracket_competition)

    const isBalanceEnough = () => {
        if(!player_balance){ return false }
        let buy_in = bracket_competition.buy_in;
        switch(bracket_competition.market_type){
            case 'FREE':
                if(player_balance.free_market_balance < buy_in){ return false }
                return true
            case 'FOR_MONEY':
                if(use_promo_balance){
                    if(player_balance.promo_balance < buy_in){ return false }
                    return true
                }
                if(player_balance.balance < buy_in){ return false }
                return true
            default: return false
        }
    }

    const handleEnter = async() => {
        if(!player){ return onRequestAuthenticate(bracket_competition?.auth_strategy_id) }
        let player_bracket_id = player_bracket?.player_bracket_id
        let new_pb:PlayerBracketProps | undefined = undefined
        if(!player_bracket_id){
            new_pb = await BracketComeptitionApi.createPlayerBracket({
                player_bracket_id: '',
                player_id: '',
                bracket_name: `${player.username} Bracket ${Math.floor(Math.random() * (100 - 1 + 1) + 1)}`,
                create_datetime: '', last_update_datetime: '',
                bracket_id: bracket_competition.bracket_id,
                completion_pct: 0,
                completion_status: 'inprogress',
                status: 'active'
            })
            player_bracket_id = new_pb.player_bracket_id
        }
        const is_enough_balance = isBalanceEnough();
        if(!is_enough_balance){ return onNotEnoughBalance({ bracket_competition }) }
        const cpb = BracketCompetitionHelpers.generateCompetitionPlayerBracket(bracket_competition.bracket_competition_id, player_bracket_id, use_promo_balance)
        onEnterCompetition(cpb, new_pb)
    }

    return (
        <View float style={{ borderRadius:8 }}>
            <View type='header' style={{ borderTopRightRadius:8, borderTopLeftRadius:8, padding:15 }}>
                <Text size={16} theme='h1'>{bracket_competition.competition_name}</Text>
            </View>
            <View style={{ justifyContent:'center', alignItems:'center' }}>
                <Image
                    source={{ uri: bracket_competition.image?.url }}
                    style={{ height:240, width:240 }}
                    resizeMode='cover'
                />
            </View>
            <View style={{ flexDirection:'row', alignItems:'center', padding:10 }}>
                <View style={{ flex:1 }}>
                    <Text size={14} theme='h1'>{player_bracket?.bracket_name ?? 'New Bracket'}</Text>
                    {player_bracket ?
                    <Text style={{ marginTop:3 }} size={12} theme='light'>{(player_bracket.completion_pct*100).toFixed(2)}% Complete</Text>
                    :<></>}
                </View>
            </View>
            {bracket_competition.opt_in_url ?
            <Button style={{ flexDirection:'row', alignItems:'center', padding:20 }} onPress={() => setDisclaimed(!disclaimed)}>
                <Checkbox size={24} checked={disclaimed} disabled onSelect={() => console.log('')}/>
                <Text theme='description' size={14} style={{ flex:1, marginLeft:10 }}>I agree to the terms and conditiions outlined <Button style={{ padding:0 }} onPress={() => Linking.openURL(bracket_competition.opt_in_url??'')}><Text size={14} theme='action'>HERE</Text></Button></Text>
            </Button>
            :<></>}
            {player && player_balance ?
            <View type='header' style={{ padding:5, marginBottom:1}}>
                <PlayerBalanceCard 
                    player={player}
                    player_balance={player_balance}
                />
            </View>
            :<></>}
            {bracket_competition.buy_in > 0 && player_balance && player_balance.promo_balance >= bracket_competition.buy_in ?
            <Button style={{ margin:10, backgroundColor:Colors.text.gold, padding:10, flexDirection:'row', alignItems:'center' }} onPress={() => {
                if(use_promo_balance){
                    //Remove promo balance and open_amt
                    setUsePromoBalance(false);
                } else {
                    setUsePromoBalance(true);                    
                }
                }}>
                    <View transparent style={{ marginRight:10, height:30, width:30, borderWidth:1, borderColor:Colors.text.h1, justifyContent:'center', alignItems:'center' }}>
                        {use_promo_balance ?
                        <View style={{ height:20, width:20, backgroundColor:Colors.text.h1 }} />
                        :<></>}
                    </View>
                    <View transparent>
                        <Text size={14} theme="h1" color={Colors.text.white}>${player_balance?.promo_balance} Promotion Available</Text>
                        <Text style={{ marginTop:2}} color={Colors.text.white} theme="description">Press / Click here to use promo balance</Text>
                    </View>
                
            </Button>
            :<></>}
            <View type='footer' style={{ flexDirection:'row', alignItems:'center', padding:10, borderBottomRightRadius:8, borderBottomLeftRadius:8 }}>
                <Button
                    title='Close'
                    style={{ flex:1, marginRight:5 }}
                    type='close'
                    onPress={() => onClose()}
                />
                <Button
                    title={buy_in_label}
                    disabled={loading || !disclaimed}
                    style={{ flex:2, opacity: !disclaimed||loading?0.5:1  }}
                    loading={loading}
                    type='success'
                    onPress={() => handleEnter()}

                />
            </View>
        </View>
    )
}

export default JoinCompetitionCard